import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'

import SupplierActions from '../../Redux/SupplierRedux'
import CreateSupplier from '../../Containers/Ecommerce/CreateSupplier'
import UpdateSupplier from '../../Containers/Ecommerce/UpdateSupplier'

class ManageSupplier extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  _fetchSupplier = (event) => {
    if (event) { event.preventDefault() }
    let filter = { page: this.state.page, limit: this.state.limit }
    this.props.getSupplier(filter)
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => { this._fetchSupplier() }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (!modalId) {
      this._fetchSupplier()
    }
  }

  _deleteSupplier = () => {
    this.props.deleteSupplier(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  componentDidMount = () => {
    this._fetchSupplier()
  }

  render () {
    const { supplier } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Suppliers
              {
                (supplier.fetching || supplier.processing) &&
                <div className='badge badge-info ml-2'>{ supplier.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button
              className='btn btn-primary'
              onClick={() => this._toggleModal('create-supplier')}
            >
              Create New Supplier
            </button>
          </div>
        </header>

        <section className='section'>
          <div className='card'>
            {
              !(supplier.fetching || supplier.processing) && supplier.err &&
              <div className='alert alert-danger'>{supplier.err}</div>
            }
            <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th className='text-center' style={{ minWidth: '200px' }}>Name</th>
                  <th className='text-center' style={{ minWidth: '200px' }}>Address</th>
                  <th className='text-center' style={{ minWidth: '200px' }}>Province</th>
                  <th className='text-center'>Edit</th>
                  <th className='text-center'>Delete</th>
                </tr>
              </thead>
              <tbody>
                {!supplier.data || !supplier.data.length
                  ? <tr>
                    <td colSpan='6' className='text-center'>No data</td>
                  </tr>
                  : supplier.data.map((item, i) => (
                    <tr key={i}>
                      <td className='text-left'>{ item.name }</td>
                      <td className='text-left'>
                        {item.supplier_address
                          ? `${item.supplier_address.address}, ${item.supplier_address.address_sub_district}, ${item.supplier_address.district.name}, ${item.supplier_address.city.name}`
                          : '-'
                        }
                        
                      </td>
                      <td className='text-center'>
                        {item.supplier_address ? item.supplier_address.province.name : '' }
                      </td>
                      <td className='text-center'>
                        <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-supplier')} >
                          <i className='fa fa-edit' />Edit
                        </button>
                      </td>
                      <td className='text-center'>
                        <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-supplier')} >
                          <i className='fa fa-trash' />Delete
                        </button>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </section>
        <section>
          {
            (supplier.data && supplier.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={supplier.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={supplier.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

        {/* Modal for create supplier */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-supplier'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateSupplier closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal for edit supplier */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-supplier'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateSupplier detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Modal for delete supplier */}
        <Modal open={this.state.showModal === 'delete-supplier'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3>Delete Supplier</h3>
            </div>
            <div className='text-center'>
              <h4>
                Confirm deletion
              </h4>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteSupplier()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  supplier: state.supplier
})

const dispatchToProps = (dispatch) => ({
  getSupplier: (filter) => dispatch(SupplierActions.getSupplierRequest(filter)),
  deleteSupplier: (id) => dispatch(SupplierActions.deleteSupplierRequest(id))
})

export default connect(stateToProps, dispatchToProps)(ManageSupplier)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageSupplier.js